import React from "react";
import { Link, useLocation } from "react-router-dom";
import NavbarLeft from "./../Components/NavbarLeft";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import { useState } from "react";
import Iframe from "react-iframe";
import ComponentLoading from "../../commonComponents/ComponentLoading";

const HelpPage = () => {
  const location = useLocation();
  const [display, setDisplay] = useState(location.state && location.state.display ? location.state.display : 1);
  const [loading, setLoading] = useState(true);

  const analyse_doc = [
    {
      title: "Méthode de l'Analyse de Cycle de Vie",
      id: 1,
      url: "https://docs.google.com/document/d/1cl5vJFdjBOaUxLZSviWcyiAkjT5vVRC8NoRcbLk5tQE/preview",
    },
    {
      title: "Bases de données",
      id: 2,
      url: "https://docs.google.com/document/d/1MWBQ-Z6BxEQWYhyS9-OCt4khkd2ALzINmP_pY2p4Zms/preview",
    },
    {
      title: "Les indicateurs d'impact",
      id: 3,
      url: "https://docs.google.com/document/d/196iixmGwuyoDbbp-6q3hROvPuJSH8HuPRVoGXseiOIg/preview",
    },
    {
      title: "Les étapes de cycle de vie",
      id: 4,
      url: "https://docs.google.com/document/d/1n4-G5_ZXK8hebbsrbuEAzqyQfSAH-H2_66kh9_9kd2Q/preview",
    },
    {
      title: "Éco-score",
      id: 5,
      url: "https://docs.google.com/document/d/1HKCr8vL7EwO3lT4cyTrDlsCqREGqZTCT34etMl3a80A/preview",
    },
    {
      title: "Processus vides",
      id: 5.5,
      url: "https://docs.google.com/document/d/1bY2VlVB6298k67wnNG3uxLJPbybccK2wRspAyHZU7TE/preview",
    },
    {
      title: "À venir",
      id: 6,
      url: "https://docs.google.com/document/d/1DwJ95jdZ9zWZHjBq77cAagCrY-6oazBdMutv5wGO9u8/preview",
    },
  ];

  const reduction_doc = [
    {
      title: "L'éco-conception",
      id: 7,
      url: "https://docs.google.com/document/d/1ogZdc3homMjUNQhpLO5R1-W2oTsiCSgMYedrtw7E9SI/preview",
    },
    {
      title: "Méthode d'identification",
      id: 8,
      url: "https://docs.google.com/document/d/11_-bP5_dEYFtmE3d0lX7LrzyasyVnQI3-g-8h0ohoxs/preview",
    },
    {
      title: "À venir",
      id: 9,
      url: "https://docs.google.com/document/d/1AgKASbpzjb2tnHeWEFlMlmB8J_0H-uuoe07ymKhEBdc/preview",
    },
  ];

  const com_doc = [
    {
      title: "Rapport automatique",
      id: 10,
      url: "https://docs.google.com/document/d/1mD0HPjN-1rRykSWi7D2cg_n0kKHmMgxF3ek8nqj0URQ/preview",
    },
    {
      title: "Kit de communication éco-score",
      id: 11,
      url: "https://docs.google.com/document/d/1LK2yRtLofwyrwI-Wenvu_RVzfJQo7bdc74xkur4Sh7w/preview",
    },
    {
      title: "Kit de communication IME",
      id: 12,
      url: "https://docs.google.com/document/d/1QDPh0Z5_9-O-nlWS_SkmgpswjCviRcXyy6xir3RDLR0/preview",
    },
    {
      title: "À venir",
      id: 13,
      url: "https://docs.google.com/document/d/1-NK3gtC9dnzfDiX2eqkBio1ZALD-Y_IOGIXtg_te0Gw/preview",
    },
  ];

  const handleChangeLoading = () => {
    setLoading(false);
  };
  return (
    <>
      <NavbarLeft currentPage={4} />
      <div className="w-full h-[70px] bg-white border-r-[1px] border-[#BEC4C] fixed z-10 flex items-center justify-start ml-[25px]">
        <div className="w-full relative left-[70px] flex justify-start items-center">
          <Link to="/Home">
            <BackArrow />
          </Link>
          <p className="font-Poppins-SemiBold text-lg relative p-10">Aide</p>
        </div>
      </div>
      <div className="flex h-full w-full">
        <div className="bg-[#F3F5F7] h-full w-[500px]">
          {/* <div className="h-[50px]" /> */}
          {/* <div className="w-full h-[70px] mt-[25px] flex items-center">
            <div className="ml-[100px]">
              <p className="font-Poppins-Regular">FAQ {display}</p>
            </div>
          </div> */}

          <div className="w-full mb-[10px] flex items-center mt-[110px]">
            <p className="ml-[100px] font-Poppins-SemiBold">Analyse de cycle de vie</p>
          </div>

          {/* ANALYSE */}
          {analyse_doc.map((x) => (
            <div
              className={(x.id === display ? "bg-white" : "") + " w-full h-[40px] hover:bg-white flex items-center"}
              onClick={() => {
                setDisplay(x.id);
                if (x.title === "Éco-score") {
                  window.open("https://docs.score-environnemental.com/", "_blank", "noopener,noreferrer");
                }
              }}
            >
              {/* <p
                className="text-black ml-[100px]"
                onClick={() => {
                  console.log( location.state.display );
                }}
              >
                DEBUG
              </p> */}
              <p className="ml-[100px] font-Poppins-Regular">{x.title}</p>
            </div>
          ))}

          {/* REDUCTION */}
          <div className=" w-full mt-[30px] mb-[10px] flex items-center">
            <p className="ml-[100px] font-Poppins-SemiBold">Reduction d'impact</p>
          </div>
          {reduction_doc.map((x) => (
            <div
              className={(x.id === display ? "bg-white" : "") + " w-full h-[40px] hover:bg-white flex items-center"}
              onClick={() => {
                setDisplay(x.id);
              }}
            >
              <p className="ml-[100px] font-Poppins-Regular">{x.title}</p>
            </div>
          ))}

          {/* COMMUNICATION */}
          <div className=" w-full mt-[30px] mb-[10px] flex items-center">
            <p className="ml-[100px] font-Poppins-SemiBold">Communication</p>
          </div>
          {com_doc.map((x) => (
            <div
              className={(x.id === display ? "bg-white" : "") + " w-full h-[40px] hover:bg-white flex items-center"}
              onClick={() => {
                setDisplay(x.id);
              }}
            >
              <p className="ml-[100px] font-Poppins-Regular">{x.title}</p>
            </div>
          ))}

          {/* REFRENCES */}
          {/* <div
            // className="w-full mt-[50px] h-[40px] hover:bg-white flex items-center"
            className={(display === 20 ? "bg-white" : "") + " w-full h-[40px] hover:bg-white flex items-center"}
            onClick={() => {
              setDisplay(20);
            }}
          >
            <p className="ml-[100px] font-Poppins-Regular">References</p>
          </div> */}
        </div>

        {/* {display === 1 && ( */}

        {false ? (
          <>
            <ComponentLoading height={35} style={"h-[400px] flex items-center justify-center"} />
          </>
        ) : (
          <>
            <Iframe
              url={
                analyse_doc.find((x) => x.id === display)
                  ? analyse_doc.find((x) => x.id === display).url
                  : reduction_doc.find((x) => x.id === display)
                  ? reduction_doc.find((x) => x.id === display).url
                  : com_doc.find((x) => x.id === display).url
              }
              //   loading={handleChangeLoading}
              onLoad={() => setLoading(false)}
              width="60%"
              height="100%"
              id="1"
              className=""
              display="block"
              position="relative"
            />
          </>
        )}

        {/* )} */}
      </div>
    </>
  );
};

export default HelpPage;
